__turbopack_context__.v({
  "description": "Textarea-module__jIt4Ra__description",
  "error": "Textarea-module__jIt4Ra__error",
  "input": "Textarea-module__jIt4Ra__input",
  "label": "Textarea-module__jIt4Ra__label",
  "required": "Textarea-module__jIt4Ra__required",
  "wrapper": "Textarea-module__jIt4Ra__wrapper",
});
